'use client';

import { LogoutButton } from '@/features/auth/logout-button';
import { useState } from 'react';
import { ArrowRightIcon } from '@phosphor-icons/react/dist/ssr';
import { Button } from '@/shared/ui/core';
import {
    RegistrationCard, RegistrationCardContent, RegistrationCardDescription, RegistrationCardHeader,
    RegistrationCardTitle,
} from '@/shared/ui/layout/registration-card';
import { PlanPicker, type PlanPickerValue } from '@/features/subscription-plan-picker';
import { useSplitWizard } from '../../model/split-wizard-context';
import { WizardFooterSplit } from '../wizard-footer-split';
import styles from './step-plan.module.scss';


const DEFAULT_VALUE: PlanPickerValue = {
    billing_period: 'monthly',
    plan_id       : '',
};


export const StepPlanSplit = () => {
    const { state, dispatch } = useSplitWizard();

    const [ value, setValue ] = useState<PlanPickerValue>(state.data.plan ?? DEFAULT_VALUE);
    const [ error, setError ] = useState<string>();

    const handleChange = (next: PlanPickerValue) => {
        setValue(next);
        if (next.plan_id) setError(undefined);
    };

    const handleNext = () => {
        if (!value.plan_id) {
            setError('Please select a plan');
            return;
        }
        dispatch({ type: 'commit', key: 'plan', value });
        dispatch({ type: 'next' });
    };

    return (
        <div>
            <RegistrationCard data-template="registration-steps-card">
                <RegistrationCardHeader data-template="registration-steps-card-header">
                    <RegistrationCardTitle data-template="registration-steps-card-title">
                        {
                            'Hello{{name}}! Let’s choose your subscription plan'.replace(
                                '{{name}}',
                                state.data.profile?.first_name ? (', ' + state.data.profile?.first_name) : '',
                            )
                        }
                    </RegistrationCardTitle>

                    <RegistrationCardDescription data-template="registration-steps-card-description">
                        Flexible options for any size of business.
                    </RegistrationCardDescription>
                </RegistrationCardHeader>

                <RegistrationCardContent data-template="registration-steps-card-content">
                    <div data-template="step-plan" className={ styles.root }>
                        <PlanPicker
                            value={ value }
                            onChange={ handleChange }
                            error={ error }
                        />
                    </div>

                </RegistrationCardContent>
            </RegistrationCard>

            <WizardFooterSplit
                state={ state }
                left={
                    <LogoutButton variant='secondary'/>
                }
                right={
                    <Button
                        onClick={ handleNext }
                        leftIcon={ <ArrowRightIcon/> }
                    >
                        Continue
                    </Button>
                }
            />
        </div>
    );
};
